export default class EinladungDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.id = json.id;
      this.token = json.token;
      this.empfaenger = json.empfaenger;
      this.createdAt = json.createdAt;
      this.validUntil = json.validUntil;
      this.status = json.status;
      this.isBrief = json.isBrief
    } else {
      this.json = {}
    }
  }

  get einladungStatus() {
    return 'einladung.status.' + this.status.toLowerCase()
  }
}
